import { Box, Stack, useTheme } from "@mui/material";
import { mdHeight } from "components/AppBar";
import { useThemeGreyBackgroundColor } from "hooks/useThemeGreyBackgroundColor";

import { ScoutChat } from "./Chat";
import { ScoutToolbar } from "./ScoutToolbar";

export function Scout() {
  const backgroundColor = useThemeGreyBackgroundColor();
  const theme = useTheme();
  return (
    <Stack
      sx={{
        width: "100%",
        height: `calc(100vh - ${theme.spacing(mdHeight)})`,
        backgroundColor,
      }}
    >
      <ScoutToolbar />
      <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
        <ScoutChat />
      </Box>
    </Stack>
  );
}
